<modal-title [title]="'Projects.PreviewHeader.stageLostModalTitle' | translate" />

<form [formGroup]="form">
  <mat-dialog-content>
    <div class="mt-3">
      <ng-select
        ngSelectExtension
        class="new-select select-default w-100 ng-select--required"
        [dropdownPosition]="'bottom'"
        [items]="stageLostReason"
        [bindValue]="'id'"
        [searchable]="false"
        [addTag]="false"
        [bindLabel]="'text'"
        [placeholder]="'Projects.PreviewHeader.chooseStageLostReason' | translate"
        [tabIndex]="-1"
        [addTagText]="'add' | translate"
        formControlName="reason"
      >
      </ng-select>
      <span
        *ngIf="form?.get('reason')?.touched && !form?.get('reason')?.value"
        class="d-flex form-control-error-msg mt-2"
        [innerHTML]="'Projects.PreviewHeader.reasonIsRequired' | translate"
      ></span>
    </div>
    <div class="mt-3">
      <textarea-v2
        class="textarea"
        [formControl]="form.get('failureNote')"
        [placeholder]="'Projects.PreviewHeader.chooseStageLostReasonDescr' | translate"
      />
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="d-flex justify-content-end">
      <app-button
        [disabled]="loading"
        (onClick)="cancel()"
        [config]="{
          type: ButtonTypes.NEW_SECONDARY_BLUE,
          text: 'Projects.PreviewHeader.cancel' | translate,
          size: ButtonSize.LARGE
        }"
      />
      <app-button
        [class]="'ml-3'"
        [loading]="loading"
        [disabled]="loading"
        (onClick)="submit()"
        [config]="{
          type: ButtonTypes.NEW_PRIMARY_BLUE,
          text: 'Projects.PreviewHeader.save' | translate,
          size: ButtonSize.LARGE
        }"
      />
    </div>
  </mat-dialog-actions>
</form>
